import { utils } from '@ps/poker-games-tile-mappers';
import classNames from 'clsx';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { Props as ButtonProps } from '@swf/components/StarsButton/RawButton';
import Button from '@swf/components/StarsButton/StarsButton';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

import { useMTTGameUrl, useOpenActiveGame } from '../../../../../../hooks/hooks';
import type { Tournament } from '../../../../../../types/MTT';

import { TXTCLI_Register__toTournament } from './Buttons.messages.json';
import styles from './Buttons.scss';

interface Props {
  tournament: Tournament;
  className?: string;
  size?: ButtonProps['size'];
}

const Buttons: React.FC<Props> = ({ tournament, className = '', size = 'small' }) => {
  const showRegisterButton = utils.mttUtils.isRegOpen(tournament.legacyStatus);
  const isAuthenticated = useSelector(select.session.isAuthenticated);
  const { modal } = useDispatch<Dispatch>();
  const tableUrl = useMTTGameUrl(tournament?.id);
  const openActiveGame = useOpenActiveGame({ tableUrl });

  const handleOnRegisterClicked = useCallback(() => {
    if (isAuthenticated) {
      openActiveGame();
    } else {
      modal.unshift({ path: '/auth/login' });
    }
  }, [isAuthenticated, modal, openActiveGame]);

  return (
    <div className={classNames(styles.buttons, className, { [styles.empty]: !showRegisterButton })}>
      {showRegisterButton && (
        <Button
          variant="primary"
          translation={TXTCLI_Register__toTournament}
          size={size}
          onClick={handleOnRegisterClicked}
        />
      )}
    </div>
  );
};

export default Buttons;
